import { withRouter } from 'react-router-dom';
import PageLayout from '../Containers/PageLayout';

export default withRouter(PageLayout);
